<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
		<!-- Debtor company data -->
		<div class="filter_item">
			<div class="filter_head">{{$t("common.debtor")}}</div>
			<EnumFilter :label-text="$t('common.status')"
						columnName="debtorState"
						:enum-def="enumDef.debtorState"
						ref="filter_debtorState"
			></EnumFilter>
			<TextFilter :label-text="$t('common.name')"
						column-name="debtorName"
						ref="filter_debtorName"
			></TextFilter>
			<FromToFilter :label-text="$t('common.cofaceDra')"
						  column-name="cofaceDra"
						  field-type="I"
						  ref="filter_cofaceDra"
			></FromToFilter>
			<IndustryFilter :label-text="$t('common.industry')"
							column-name="debtorIndustryId"
							ref="filter_debtorIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="$t('common.country')"
						   :company-type="enumDef.companyType.DebtorCompany"
						   column-name="debtorCountry"
						   ref="filter_debtorCountry">
			</CountryFilter>
			<TextFilter :label-text="$t('common.city')"
						column-name="debtorCity"
						ref="filter_debtorCity"
			></TextFilter>
		</div>
		<!-- Debtor relation data -->
		<div class="filter_item">
			<div class="filter_head">{{$t("common.relation")}}</div>
			<TextFilter :label-text="$t('common.customerReference')"
						column-name="customerReference"
						ref="filter_customerReference"
			></TextFilter>
			<CountryFilter :label-text="$t('common.applicableLaw')"
						   :companyType="enumDef.companyType.DebtorCompany"
						   column-name="applicableLaw"
						   ref="filter_applicableLaw"
			></CountryFilter>
			<FromToFilter :label-text="$t('debtorManagement.overview.net')"
						  column-name="historicalPaymentDays"
						  field-type="I"
						  ref="filter_historicalPaymentDays"
			></FromToFilter>
			<FromToFilter :label-text="$t('common.discountRate')"
						  column-name="discountRate"
						  ref="filter_discountRate"
			></FromToFilter>
		</div>
    </TableFilter>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

import EnumFilter from "@/components/newFilter/EnumFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import IndustryFilter from "@/components/newFilter/IndustryFilter";
import CountryFilter from "@/components/newFilter/CountryFilter";
import TableFilter from "@/components/newFilter/TableFilter";

export default {
    components: {
		TableFilter,
		IndustryFilter,
		TextFilter,
		EnumFilter,
		FromToFilter,
		CountryFilter
	},
    data() {
        return {
            enumDef: enumDef,
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>